import { memo, ReactNode } from "react";
import classNames from "classnames";
import { PageLayout, PageLayoutProps } from "../PageLayout";

import styles from "./style.module.scss";

export type EntityPageLayoutProps = PageLayoutProps & {
  isFetching?: boolean
  fullPageContent?: ReactNode | ReactNode[]
  rightPanel?: ReactNode | ReactNode[]
  loadingClassName?: string,
  entityContentClassName?: string,
  entityContentWithRightPanelClassName?: string,
};

export const EntityPageLayout = memo<EntityPageLayoutProps>((
  {
    isFetching = false,
    fullPageContent,
    rightPanel,
    children,
    loadingClassName,
    entityContentClassName,
    entityContentWithRightPanelClassName,
    ...restProps
  }) => {

  const withRightPanel = !!rightPanel;

  return (
    <PageLayout {...restProps}>
      <div className={classNames(
        styles.content,
        entityContentClassName,
        {
          [styles.withRightPanel]: withRightPanel,
          entityContentWithRightPanelClassName: withRightPanel,
          [styles.loading]: isFetching,
          [loadingClassName || ""]: isFetching,
        },
      )}>
        <div>{children}</div>
        {rightPanel && <div>{rightPanel}</div>}
        {
          fullPageContent &&
          <div className={styles.fullPageContent}>
            {fullPageContent}
          </div>
        }
      </div>
    </PageLayout>
  );
});

export default EntityPageLayout;
